import React, { useEffect, useRef, useState } from 'react';
import "./SignUpModal.css"
import axios from 'axios';

export default function SignupModal() {
    const [isOpen, setIsOpen] = useState(false);
    const modalRef = useRef(null);
    const openButtonRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null)
    const [formData, setformData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        domain: "",
        phone: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newData = { ...formData, [name]: value };
        setformData(newData);
    };

    // Focus trap helpers
    useEffect(() => {
        function handleKeyDown(e) {
            if (!isOpen) return;
            if (e.key === 'Escape') {
                e.preventDefault();
                closeModal();
            }
            if (e.key === 'Tab') {
                const focusableElements = modalRef.current.querySelectorAll(
                    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
                );
                if (focusableElements.length === 0) {
                    e.preventDefault();
                    return;
                }
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                if (e.shiftKey) {
                    // Shift + Tab
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                } else {
                    // Tab
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        }
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            // Focus modal on open
            modalRef.current?.focus();
            // Prevent body scroll
            document.body.style.overflow = 'hidden';
        } else {
            document.removeEventListener('keydown', handleKeyDown);
            // Restore body scroll
            document.body.style.overflow = '';
            // Return focus to open button
            openButtonRef.current?.focus();
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    const backendUrl = "https://backend.globedwise.com/bibekTrust"

    const submitForm = async(e) => {
        e.preventDefault()
        // alert("Form Submit")
        console.log(formData, "formdata")
        // if (
        //     formData.name === "" ||
        //     !isValidEmail(formData.emailaddress)
        // ) {
        //     setMessage("Please fill all the fields");
        //     return;
        // }
        // API call to submit form data
        try {
            setLoading(true);
            const res = await axios.post(backendUrl, {
                data: [
                    {
                        Name: formData.firstName,
                        Last_Name: formData.lastName,
                        Email: formData.email,
                        Mobile: formData.phone,
                        Domain: formData.domain,
                        Lead_Source: "Volunteer Page"
                    }
                ]
            });
            // console.log(res, "res")
            // userData(formData);
            setLoading(false);
            setMessage("Form submitted successfully");
            setformData({firstName: "", lastName: "", email: "", domain: ""})
            closeModal()
            alert("Sign up successfully");
            // onClose();
        } catch (error) {
            setLoading(false);
            setMessage("Something went wrong, please try again");
            console.log(error);
        } finally {
            setLoading(false);
        }

    }

    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
        setMessage(null)
    }

    // Close modal if click outside modal content
    function onBackdropClick(e) {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    }

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <button
                    className="open-modal-btn blinking-button"
                    onClick={openModal}
                    aria-haspopup="dialog"
                    aria-controls="signupModal"
                    aria-expanded={isOpen}
                    ref={openButtonRef}
                >
                    Volunteer Sign-Up
                </button>
            </div>
            {isOpen && (
                <div
                    className="modal-backdrop"
                    id="signupModal"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modalTitle"
                    tabIndex={-1}
                    onClick={onBackdropClick}
                    ref={modalRef}
                >
                    <div className="modal" role="document">
                        <button
                            className="close-modal-btn"
                            aria-label="Close signup form"
                            onClick={closeModal}
                        >
                            &times;
                        </button>
                        <h2 id="modalTitle">Signup as Volunteer</h2>
                        {message ? <p style={{textAlign: "center", color: "tomato"}}>{message}</p> : ""}
                        <form
                            className="signup-form"
                            onSubmit={submitForm}
                            noValidate
                        >
                            <label htmlFor="firstName">First Name</label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                                autoComplete="name"
                                placeholder="Your First Name"
                            />
                            <label htmlFor="lastName">Last Name</label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                                autoComplete="name"
                                placeholder="Your last Name"
                            />
                            <label htmlFor="emailAddress">Email Address</label>
                            <input
                                type="email"
                                id="emailAddress"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                autoComplete="email"
                                placeholder="your.email@example.com"
                            />
                            <label htmlFor="phoneNumber">Phone Number</label>
                            <input
                                type="number"
                                id="phoneNumber"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                autoComplete="billing mobile tel-local-prefix"
                                placeholder="1010101010"
                            />
                            <label htmlFor="domainVolunteer">In which Domain you can volunteer</label>
                            <select
                                id="domainVolunteer"
                                name="domain"
                                value={formData.domain}
                                onChange={handleChange}
                                defaultValue=""
                                required
                            >
                                <option value="" disabled>
                                    Select a domain...
                                </option>
                                <option value="Doctor">Doctor</option>
                                <option value="Teacher">Teacher</option>
                                <option value="Career Counselor">Career Counselor</option>
                                <option value="Social Worker">Social Worker</option>
                                <option value="Lawyer">Lawyer</option>
                                <option value="Environmentalist">Environmentalist</option>
                                <option value="Event Coordinator">Event Coordinator</option>
                                <option value="Administrative Support">Administrative Support</option>
                                <option value="Other">Other</option>
                            </select>
                            <button type="submit" className="submit-btn" disabled={loading ? true: false}>
                                {loading? "Wait...": "Sign Up"}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}



